const formLabelFormCreateUser = {
  text: 'Tipo de Acceso'
};

export default formLabelFormCreateUser;
